/*
 * dispenseEproDevicePopupComponent
 * */

import templateUrl from './dispenseEproDevicePopup.html';
import controller from './dispenseEproDevicePopup.controller';
import './dispenseEproDevicePopup.scss';

const dispenseEproDevicePopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default dispenseEproDevicePopupComponent;
